import {noop} from '@benchling/js-utils';

import {makeReactContext} from 'lib/makeReactContext';

/**
 * Edge-level actions for the procedure run design flowchart. Provided via context so handlers
 * stay stable. Defaults to no-ops outside the editor.
 */
export interface ProcedureRunDesignFlowchartEdgeActions {
  /** Removes an edge by id and records the change in the edit state. */
  onRemoveEdge: (edgeId: string) => void;
}

export const ProcedureRunDesignFlowchartEdgeActionsContext =
  makeReactContext<ProcedureRunDesignFlowchartEdgeActions>(
    () => ({onRemoveEdge: noop}),
    'ProcedureRunDesignFlowchartEdgeActionsContext'
  );

export const useProcedureRunDesignFlowchartEdgeActions =
  ProcedureRunDesignFlowchartEdgeActionsContext.useContext;
